/*
  bs: age / pickup-only gate driven by the custom.age_restriction and
  custom.ships_individually product metafields.
  Rendered by snippets/bs-buy-buttons.liquid inside the product form.
  Locks the add-to-cart button (aria-disabled, which product-form.js
  already honours) until EVERY confirmation checkbox in the gate is
  ticked, blocks any submit while locked, and re-applies the lock after
  a variant change (product-info.js re-enables the button via
  toggleSubmitButton).
*/
if (!customElements.get('bs-restricted-gate')) {
  customElements.define(
    'bs-restricted-gate',
    class BsRestrictedGate extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        this.productForm = this.closest('product-form');
        this.checkboxes = Array.from(this.querySelectorAll('input[type="checkbox"]'));
        this.button = this.form ? this.form.querySelector('button[type="submit"][name="add"]') : null;
        if (!this.form || !this.checkboxes.length || !this.button) return;

        this.onChange = () => {
          this.apply();
          if (this.allChecked() && this.productForm?.handleErrorMessage) {
            this.productForm.handleErrorMessage(false);
          }
        };
        this.onSubmit = (evt) => {
          if (this.allChecked()) return;
          evt.preventDefault();
          evt.stopImmediatePropagation();
          this.apply();
          if (this.productForm?.handleErrorMessage) {
            this.productForm.handleErrorMessage(this.dataset.error || '');
          }
          this.firstUnchecked()?.focus();
        };

        this.checkboxes.forEach((cb) => cb.addEventListener('change', this.onChange));
        this.form.addEventListener('submit', this.onSubmit, true);
        if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
          this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, () => this.apply());
        }
        this.apply();
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.onSubmit, true);
        this.unsubscribeVariantChange?.();
      }

      allChecked() {
        return this.checkboxes.every((cb) => cb.checked);
      }

      firstUnchecked() {
        return this.checkboxes.find((cb) => !cb.checked);
      }

      apply() {
        const locked = !this.allChecked();
        if (locked) {
          this.button.setAttribute('aria-disabled', 'true');
        } else if (!this.button.classList.contains('loading')) {
          this.button.removeAttribute('aria-disabled');
        }
        this.button.classList.toggle('bs-restricted-locked', locked);
      }
    }
  );
}
